<template>
    <div>
        <el-table ref="table"
                  :highlight-current-row="true"
                  @selection-change="selection"
                  v-adaptive="{bottomOffset: adaptiveHeight}"
                  height="800"
                  border
                  :showSummary="showSummary"
                  :summary-method="getSummaries"
                  :data="dataList"
                  @sort-change="sortChange"
                  @row-click="rowClick"
                  @row-dblclick="dbClick"
                  v-loading="loading"
                  :header-cell-style="headerStyle"
                  :cell-style="cellStyle"
                  element-loading-text="正在加载中..."
                  element-loading-spinner="el-icon-loading">
            <tableColumn :headList="headList" :pageInfo="pageInfo" @tableOpt="tableOpt"></tableColumn>
        </el-table>
        <div class="pagStyle">
            <pagination :pageInfo="pageInfo" @toPage="toPage"></pagination>
        </div>
    </div>
</template>

<script>
    import adaptive from '@/components/element/el-table/index'
    import tableColumn from "./tableColumn";
    import pagination from "./pagination";

    export default {
        name: "tableGrid",
        directives: {adaptive},
        props: {
            showSummary: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: false
            },
            adaptiveHeight: {
                type: String,
                default: "85"
            },
            tableData: {
                type: Array,
                default: () => []
            },
            headList: {
                type: Array,
                default: () => []
            },
            dataList: {
                type: Array,
                default: () => []
            },
            pageInfo: {
                type: Object,
                default: () => ({
                    page: 1,
                    pagesize: 20,
                    pageSizes: [10, 20, 50, 100,200,2000],
                    total: 0,
                })
            },
            sumObject: {
                type: Object,
                default: () => ({
                    taxTotal:0,
                })
            }
        },
        components: {
            tableColumn,
            pagination
        },
        data() {
            return {
                list: [],
                selRow: {},
            }
        },
        mounted() {

        },
        updated () {
            this.$nextTick(() => {
                this.$refs.table.doLayout(); //解决表格错位
            });
        },
        methods: {
            headerStyle() {
                return "text-align:center;height: 35px;line-height: 35px;padding: 5px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle({row}) {
                if(row.cancelState===1) {
                    return "color:red;text-align:center;"
                }else{
                    return "text-align:center;"
                }
            },
            selection(list) {
                this.list = list;
            },
            getList() {
                return this.list;
            },
            getSelList() {
                return this.selRow;
            },
            clearSelList() {
                this.selRow = {};
            },
            sortChange() {
                this.$emit("sortChange")
            },
            tableOpt(type, row) {
                this.$emit('tableOpt', type, row)
            },
            // 点击表格行操作
            rowClick(row) {
                this.selRow = row;
                // this.$emit("rowClick", row)
            },
            dbClick() {
                // this.$emit('tableOpt', 'edit', row)
            },
            toPage(obj) {
                this.$emit('toPage', obj)
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    //const values = data.map(item => Number(item[column.property]));
                    let field=column.property;
                    switch (field) {
                        case "num":
                            sums[index]=this.$pub.getPrecisionData(this.sumObject.num,this.precisionTotal);
                            break;
                        case "total":
                            sums[index]=this.$pub.getPrecisionData(this.sumObject.total,this.precisionTotal);
                            break;
                        case "tax":
                            sums[index]=this.$pub.getPrecisionData(this.sumObject.tax,this.precisionTotal);
                            break;
                        case "billTotal":
                            sums[index]=this.$pub.getPrecisionData(this.sumObject.billTotal,this.precisionTotal);
                            break;
                        case "taxTotal":
                            sums[index]=this.$pub.getPrecisionData(this.sumObject.taxTotal,this.precisionTotal);
                            break;
                        case "costTotal":
                            sums[index]=this.$pub.getPrecisionData(this.sumObject.costTotal,this.precisionTotal);
                            break;
                        case "profitTotal":
                            sums[index]=this.$pub.getPrecisionData(this.sumObject.profitTotal,this.precisionTotal);
                            break;
                        case "endNum":
                            sums[index]=this.$pub.getPrecisionData(this.sumObject.endNum,this.precisionTotal);
                            break;
                        case "endTotal":
                            sums[index]=this.$pub.getPrecisionData(this.sumObject.endTotal,this.precisionTotal);
                            break;
                        case "sumNum":
                            sums[index]=this.$pub.getPrecisionData(this.sumObject.sumNum,this.precisionTotal);
                            break;
                        case "sumTotal":
                            sums[index]=this.$pub.getPrecisionData(this.sumObject.sumTotal,this.precisionTotal);
                            break;
                        case "debitTotal":
                            sums[index]=this.$pub.getPrecisionData(this.sumObject.debitTotal,this.precisionTotal);
                            break;
                        case "creditTotal":
                            sums[index]=this.$pub.getPrecisionData(this.sumObject.creditTotal,this.precisionTotal);
                            break;
                        case "settleTotal":
                            sums[index]=this.$pub.getPrecisionData(this.sumObject.settleTotal,this.precisionTotal);
                            break;
                        case "noSettleTotal":
                            sums[index]=this.$pub.getPrecisionData(this.sumObject.noSettleTotal,this.precisionTotal);
                            break;
                        case "intoNum":
                            sums[index]=this.$pub.getPrecisionData(this.sumObject.intoNum,this.precisionTotal);
                            break;
                        case "intoTotal":
                            sums[index]=this.$pub.getPrecisionData(this.sumObject.intoTotal,this.precisionTotal);
                            break;
                        case "outNum":
                            sums[index]=this.$pub.getPrecisionData(this.sumObject.outNum,this.precisionTotal);
                            break;
                        case "outTotal":
                            sums[index]=this.$pub.getPrecisionData(this.sumObject.outTotal,this.precisionTotal);
                            break;
                    }
                });

                return sums;
            },
        }
    }
</script>

<style scoped>
    .pagStyle {
        /*margin-bottom: 30px;*/
        /*position:absolute;*/
        width: 100%;
        margin-top: 10px;
        /*bottom: 20px;*/
        text-align: center;
    }

    .headerStyle {
        padding: 0;
        height: 48px;
        line-height: 48px;
    }

    /deep/ .el-table .el-table__cell {
        padding: 8px;
    }
    /deep/ .el-table .el-input__inner{
        -webkit-appearance: none;
        background-color: #FFF;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 35px;
        line-height: 40px;
        outline: 0;
        /* padding: 0 15px; */
        -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
        transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
        width: 100%;
    }

    /*.el-table td, .el-table th {*/
    /*    padding: 10px;*/
    /*}*/
    /deep/ .el-table {
        overflow-y: auto !important;
    }

    /deep/ .el-table__body tr.current-row > td.el-table__cell {
        background-color: #66c4f6;
    }

    /deep/ .el-table__footer-wrapper td.el-table__cell {
        border-top: 1px solid #EBEEF5;
        white-space: nowrap;
        text-align:center;
    }

</style>
